import { render, staticRenderFns } from "./onlyList.vue?vue&type=template&id=180f5e34&scoped=true"
import script from "./onlyList.vue?vue&type=script&lang=js"
export * from "./onlyList.vue?vue&type=script&lang=js"
import style0 from "./onlyList.vue?vue&type=style&index=0&id=180f5e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f5e34",
  null
  
)

export default component.exports